/* Bundle contents pill nav (OL-3760).

   Pills are server-rendered anchor links to each card's id, so they still
   navigate with no JS. This script turns them into tabs: it adds the
   .is-enhanced class that switches the section from every-card-stacked to
   one card at a time, then swaps the visible card on click. Without it the
   section stays stacked - degraded, never blank.

   Mobile used to be a scroll-snap carousel with its own dot row, which gave
   the same cards two competing controls on one screen. The pills are now the
   only control on both breakpoints. */
(() => {
  function wire(root) {
    if (root.dataset.bcWired) return;
    root.dataset.bcWired = 'true';

    const cards = Array.from(root.querySelectorAll('[data-bundle-contents-card]'));
    const pills = Array.from(root.querySelectorAll('[data-bundle-contents-pill]'));
    if (!cards.length) return;

    root.classList.add('is-enhanced');

    function setActive(index) {
      cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
      pills.forEach((pill, i) => {
        pill.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    pills.forEach((pill, i) => {
      pill.addEventListener('click', (event) => {
        event.preventDefault();
        setActive(i);
      });
    });

    setActive(0);
  }

  function wireAll() {
    document.querySelectorAll('[data-bundle-contents]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  document.addEventListener('shopify:section:load', wireAll);
})();
